import classNames from 'classnames';
import { useCallback } from 'react';

import Icon from './Icon';

type PropsButtonLink = {
  children?: JSX.Element;
  href?: string;
  target?: string;
  className?: string;
  style?: object;
  icon?: string;
  swap?: boolean;
  classIcon?: string;
  size?: 'sm' | 'lg';
  theme?: string;
  outline?: boolean;
  rounded?: boolean;
  buttonProps?: object;
  iconProps?: object;
}

export function ButtonLink(
  {
    children,
    href,
    target,
    className,
    style = {},
    icon,
    swap = false,
    classIcon,
    size,
    theme = 'primary',
    outline = false,
    rounded = false,
    buttonProps = {},
    iconProps = {}
  }: PropsButtonLink
) {
  const renderIcon = useCallback((internalClassIcon) => {
    if (!icon) {
      return null;
    }
    return (
      <Icon
        icon={icon}
        className={classNames(
          classIcon,
          children && internalClassIcon
        )}
        {...iconProps}
      />
    );
  }, [children, classIcon, icon, iconProps]);
  return (
    <a
      role="button"
      href={href}
      className={classNames(
        'btn',
        `btn-${outline ? 'outline-' : ''}${theme}`,
        !children && 'btn-icon',
        size && `btn-${size}`,
        rounded && 'btn-rounded',
        className
      )}
      style={style}
      {...target && { target }}
      {...buttonProps}
    >
      {!swap && renderIcon('me-2')}
      {children}
      {swap && renderIcon('ms-2')}
    </a>
  );
}

export default ButtonLink;
